import { useContext } from 'react';
import PropTypes from 'prop-types';
import { StatusContext } from './StatusContext';

export default function Status({ code, redirectURL, children }) {
	const ctx = useContext(StatusContext);
	if (ctx) {
		ctx.status = code;
		if (redirectURL) ctx.redirectURL = redirectURL;
	}
	return children || null;
}

Status.propTypes = {
	code: PropTypes.number.isRequired,
	redirectURL: PropTypes.string,
	children: PropTypes.node,
};
